import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Link,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import { Box } from "@mui/system";
import { IoCloseOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function KycDialog(props) {
  const { setSelectedKyc, selectedKyc } = props;
  const navigate = useNavigate();

  const handleClose = () => {
    setSelectedKyc(false);
  };
  return selectedKyc ? (
    <Dialog
      open={selectedKyc ? true : false}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <Box flexGrow={1} className="font-extrabold text-lg">
            View KYC
          </Box>
          <Box>
            <IconButton onClick={handleClose}>
              <IoCloseOutline />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <div className="grid" style={{ minWidth: "450px" }}>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Firstname
                </TableCell>
                <TableCell className="">{selectedKyc.firstname}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Lastname
                </TableCell>
                <TableCell className="">{selectedKyc.lastname}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Mobile
                </TableCell>
                <TableCell className="">{selectedKyc.mobile}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Email
                </TableCell>
                <TableCell className="">{selectedKyc.email}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Address
                </TableCell>
                <TableCell className="">{selectedKyc.address}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  City
                </TableCell>
                <TableCell className="">{selectedKyc.city}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  State
                </TableCell>
                <TableCell className="">{selectedKyc.state}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Pincode
                </TableCell>
                <TableCell className="">{selectedKyc.pincode}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Education
                </TableCell>
                <TableCell className="">{selectedKyc.education}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Skills
                </TableCell>
                <TableCell className="">
                  {selectedKyc.skills.toString()}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Experience
                </TableCell>
                <TableCell className="">{selectedKyc.experience}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Languages
                </TableCell>
                <TableCell className="">
                  {selectedKyc.languages.toString()}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  Mentor Reason
                </TableCell>
                <TableCell className="">
                  {selectedKyc.mentorSurveyReason}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-extrabold"
                  style={{ fontWeight: "bold" }}
                >
                  ID Proof Type
                </TableCell>
                <TableCell className="">{selectedKyc.idProof.type}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      </DialogContent>
      <DialogActions>
        <Link href={selectedKyc.resumeUrl}>
          <Button size="small">DOWNLOAD Resume</Button>
        </Link>
        <Link href={selectedKyc.idProof.url}>
          <Button size="small">DOWNLOAD ID-Proof</Button>
        </Link>
      </DialogActions>
    </Dialog>
  ) : (
    ""
  );
}

export default KycDialog;
